"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntl = require("react-intl");
var _Box = _interopRequireDefault(require("@quintoandar/cozy-core/Box"));
var _Input = _interopRequireDefault(require("./Input"));
var _proptypes = _interopRequireDefault(require("./proptypes"));
var _ValidationErrors = _interopRequireDefault(require("../ValidationErrors"));
var _useValidation2 = _interopRequireDefault(require("../Form/hooks/useValidation"));
var _a11y = require("../Form/a11y");
var _excluded = ["name", "validators", "initialValue", "variant", "required", "minLength", "maxLength", "intl", "skipRegister"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var Input = function Input(_ref) {
  var name = _ref.name,
    validators = _ref.validators,
    initialValue = _ref.initialValue,
    variant = _ref.variant,
    required = _ref.required,
    minLength = _ref.minLength,
    maxLength = _ref.maxLength,
    intl = _ref.intl,
    skipRegister = _ref.skipRegister,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useValidation = (0, _useValidation2["default"])(name, intl, validators, {
      required: required,
      maxLength: maxLength,
      minLength: minLength
    }, [validators, required, maxLength, minLength]),
    rules = _useValidation.rules,
    errors = _useValidation.errors,
    register = _useValidation.register;
  var errorId = (0, _a11y.a11yErrorId)(name);

  // eslint-disable-next-line react/prop-types
  var refToBePassed = skipRegister ? props.inputProps.ref : register(rules);
  return /*#__PURE__*/_react["default"].createElement(_Box["default"], null, /*#__PURE__*/_react["default"].createElement(_Input["default"], _extends({
    ref: refToBePassed,
    name: name,
    initialValue: initialValue,
    error: errors.length >= 1,
    maxLength: maxLength,
    required: required,
    "aria-describedby": errorId
  }, props)), /*#__PURE__*/_react["default"].createElement(_ValidationErrors["default"], {
    id: errorId,
    errors: errors,
    variant: variant
  }));
};
Input.propTypes = process.env.NODE_ENV !== "production" ? {
  name: _propTypes["default"].string.isRequired,
  validators: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    rule: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]).isRequired,
    value: _propTypes["default"].any,
    message: _propTypes["default"].string.isRequired
  })),
  initialValue: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  variant: _proptypes["default"],
  required: _propTypes["default"].bool,
  minLength: _propTypes["default"].number,
  maxLength: _propTypes["default"].number,
  skipRegister: _propTypes["default"].bool,
  intl: _propTypes["default"].object.isRequired
} : {};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)((0, _reactIntl.injectIntl)(Input));